import { useNavigate } from '@reach/router';
import classes from 'classnames';
import React from 'react';
import styles from './BundleBadge.module.scss';
import VivusplusFilledIcon from 'assets/icons/bundle/vivusplus-filled.svg?react';
import VivusplusIcon from 'assets/icons/bundle/vivusPlus.svg?react';

type Props = {
  className?: string;
  iconFilled?: boolean;
  text?: string;
  layoutView?: 'desktop' | 'mobile';
  route?: string;
};

export const BundleBadge = ({
  className,
  iconFilled = false,
  text,
  layoutView,
  route,
}: Props) => {
  const navigate = useNavigate();
  const isClickable = Boolean(route);

  const handleBadge = () => route && navigate(route);

  return (
    <span
      className={classes(
        styles.badge,
        layoutView && styles[layoutView],
        isClickable && styles.clickable,
        className,
      )}
      data-test="bundle-badge"
      onClick={handleBadge}
    >
      {iconFilled ? (
        <VivusplusFilledIcon data-test="bundle-badge-icon" />
      ) : (
        <VivusplusIcon data-test="bundle-badge-icon" />
      )}
      {text}
    </span>
  );
};
